import { render, staticRenderFns } from "./ReceiverInfo.vue?vue&type=template&id=6f0606f8"
import script from "./ReceiverInfo.vue?vue&type=script&lang=js"
export * from "./ReceiverInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports